import { types } from "redux/reducers/crmReducer";
import { api_put } from "services/api";
import { PROYECT } from "services/api";
import { api_post } from "services/api";
import { api_get } from "services/api";
import { setSnackbar, startRequest, startRequestComp, stopRequest, stopRequestComp } from "./search/searchActions";
import { api_delete } from "services/api";
import axios from "axios";

const mainUrl = `${process.env.REACT_APP_URL}${PROYECT}`

export const getCustomerInfo = (customerId) => {
  const url = `${mainUrl}/customer/${customerId}`
  return async (dispatch) => {
    await api_get(url).then(resp => {

    })
  }
}

export function loadStationsAction() {
  return {
    type: types.LOAD_STATIONS,
  };
}
export function loadCustomers(phone) {
  return {
    type: types.LOAD_CUSTOMERS,
    phone,
  };
}

export function loadCustomer(id) {
  return {
    type: types.LOAD_CUSTOMER,
    id,
  };
}

export function loadMenuData(idAccount, idStation, type) {
  return {
    type: types.LOAD_MENU_DATA,
    payload: {
      idAccount,
      idStation,
      type,
    },
  };
}

export function setMenuData(idAccount, idStation, type) {
  return {
    type: types.SET_MENU_DATA,
    payload: {
      idAccount,
      idStation,
      type,
    },
  };
}
export function clearUnitsAction() {
  return {
    type: types.CLEAR_UNITS,
  };
}
export function loadServicesAction(id) {
  return {
    type: types.LOAD_ORDERS,
    id,
  };
}
export function setCustomerAction({
  customer,
  accounts = [],
  accountsMap = null,
  phone = {},
}) {
  return {
    type: types.SET_CUSTOMER,
    payload: {
      customer,
      accounts,
      accountsMap,
      phone,
    },
  };
}

export function setCustomerFetchAction({
  customer,
  accounts = [],
  accountsMap = null,
  phone = {},
}) {
  return {
    type: types.SET_CUSTOMER_FETCH,
    payload: {
      customer,
      accounts,
      accountsMap,
      phone,
    },
  };
}

export function sendCustomerAction(body, isEdit, id = null) {
  return {
    type: types.SEND_CUSTOMER,
    payload: {
      body,
      isEdit,
      id,
    },
  };
}
export function sendAccountAction(body, isEdit, idCustomer, idAccount) {
  return {
    type: types.SEND_ACCOUNT,
    payload: {
      body,
      isEdit,
      idCustomer,
      idAccount,
    },
  };
}
export function sendOrderAction(body) {
  return {
    type: types.SEND_ORDER,
    payload: {
      body,
    },
  };
}
export function changeAccountAction(selectedAccount) {
  return {
    type: types.CHANGE_ACCOUNT,
    payload: {
      selectedAccount,
    },
  };
}
export function changeAccountServiceAction(selectedAccount) {
  return {
    type: types.CHANGE_ACCOUNT_SERVICE,
    payload: {
      selectedAccount,
    },
  };
}
export function clearCrm() {
  return {
    type: types.CLEAR_CUSTOMERS,
  };
}

// START V2 ACTIONS

export const suscriptionForm = (data) => {
  return {
    type: types.SUSCRIPTION_FORM,
    payload: data
  }
}

export const getCycles = (token) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/accounts/cycles/types`
  const headers = { headers: { Authorization: token } }
  return async (dispatch) => {
    await api_get(url, headers).then(resp => {
      dispatch({
        type: types.GET_SUSCRIPTION_CYCLES,
        payload: resp
      })
    })
  }
}
//http://localhost:3000/admin/cliente/64bd5bd5-afbc-497b-a1ef-49eda2960f61
export const createCycle = (id, form, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/accounts/${id}/cycles`
  const headers = { headers: { Authorization: token } }
  return async (dispatch) => {
    await api_post(url, form, headers).then(resp => {
      dispatch({
        type: types.CREATE_CYCLE,
        payload: { ...resp, idAccount: id }
      })
      dispatch(crmSnackbarAction({
        message: 'Cyclo creado con éxito',
        color: 'success'
      }))
    }).catch(err => {
      dispatch(crmSnackbarAction({
        message: err,
        color: 'danger'
      }))
    })
  }
}
export const editCycle = (idAccount, id, form, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/accounts/${idAccount}/cycles/${id}`
  const auth = { headers: { Authorization: token } }
  return async (dispatch) => {
    await api_put(url, form, auth).then(resp => {
      dispatch({
        type: types.EDIT_CYCLE,
        payload: resp
      })
      dispatch(crmSnackbarAction({
        message: 'Cyclo editado con éxito',
        color: 'success'
      }))
    }).catch(err => {
      dispatch(crmSnackbarAction({
        message: err,
        color: 'danger'
      }))
    })
  }
}
export const deleteCycleAction = (idAccount, id, form, token) => {
  const url = `${process.env.REACT_APP_URL}/crm/accounts/${idAccount}/cycles/${id}`
  const auth = { headers: { Authorization: token } }
  return async (dispatch) => {
    await api_put(url, form, auth).then(resp => {
      dispatch({
        type: types.DELETE_CYCLE,
        payload: idAccount
      })
      dispatch(crmSnackbarAction({
        message: 'Cyclo cancelado con éxito',
        color: 'success'
      }))
    }).catch(err => {
      dispatch(crmSnackbarAction({
        message: err,
        color: 'danger'
      }))
    })
  }
}

export const editModeCycle = (isEdit) => {
  return {
    type: types.IS_EDIT_SUSCRIPTION,
    payload: isEdit
  }
}

export const suscriptionModeAction = () => {
  return {
    type: types.SET_SUSCRIPTION
  }
}

export const resetSuscriptionModeAction = () => {

  return {
    type: types.RESET_SUSCRIPTION
  }
}
export const resetCrmSnackBar = () => {

  return {
    type: types.CRM_RESET_SNACKBAR
  }
}

export const crmSnackbarAction = (data) => {
  return {
    type: types.CRM_SNACKBAR,
    payload: data
  }
}

export const getCustomerConditions = (id) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/customers/${id}/customers-conditions`
  return async (dispatch) => {
    dispatch(startRequest())
    await api_get(url).then(resp => {
      dispatch({
        type: types.GET_CUSTOMER_CONDITIONS,
        payload: resp
      })
      dispatch(stopRequest())
    }).catch(err => {
      const message = err ? err : 'Error en la solicitud'
      dispatch(setSnackbar(message))
    })
  }
}

export const saveCustomerConditions = (id, form) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/customers/${id}/customer-conditions`

  return async (dispatch) => {
    await api_post(url, form).then(resp => {
      dispatch(startRequestComp())
      dispatch({
        type: types.CRM_SAVE_CONDITION,
        payload: resp
      })
      dispatch(stopRequestComp("component"))
      dispatch(setSnackbar('Guardado', 'success'))
    }).catch(err => {
      const message = err ? err : 'Error en la solicitud'
      dispatch(setSnackbar(message))
    })
  }
}

export const crmAddCondition = (id, form) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/customers/${id}/customer-conditions`

  return async (dispatch) => {
    await api_post(url, form).then(resp => {
      dispatch(startRequestComp())
      dispatch({
        type: types.CRM_SAVE_CONDITION,
        payload: resp
      })
      dispatch(stopRequestComp("component"))
      dispatch(setSnackbar('Guardado', 'success'))
    }).catch(err => {
      const message = err ? err : 'Error en la solicitud'
      dispatch(setSnackbar(message))
    })
  }
}
export const crmEditCondition = (customerId, conditionId, body) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/customers/${customerId}/conditions/${conditionId}`
  return async (dispatch) => {
    await api_put(url, body).then(resp => {
      dispatch({
        type: types.EDIT_CUSTOMER_CONDITION,
        payload: resp
      }
      )
      dispatch(setSnackbar('Condición modificada', 'success'))
    }).catch(err => {
      dispatch(setSnackbar(err || 'Error al eliminar'))
    })
  }
}

export const crmRemoveCondition = (customerId, conditionId) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/customers/${customerId}/customers-conditions/${conditionId}`
  return async (dispatch) => {
    await api_delete(url).then(resp => {
      dispatch({
        type: types.DELETE_CUSTOMER_CONDITION,
        payload: conditionId
      }
      )
      dispatch(setSnackbar(resp?.message, 'success'))
    }).catch(err => {
      dispatch(setSnackbar(err || 'Error al eliminar'))
    })
  }
}

export const getCustomerContracts = (id) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/customers/${id}/contracts`
  return async (dispatch) => {
    dispatch(startRequestComp())
    await api_get(url).then(resp => {
      dispatch({
        type: types.GET_CONTRACTS,
        payload: resp
      })
      dispatch(stopRequestComp("component"))
    }).then(err => {
      console.log(err)
      // dispatch( setSnackbar('error') )
    })
  }
}

export const uploadPdfContract = (id, form, token) => {
  const url = `${process.env.REACT_APP_URL}${PROYECT}/customers/${id}/contract-files`;
  const auth = {
    headers: {
      'Content-Type': 'multipart/form-data',
      'Authorization': token
    },
  }

  // debugger
  return async (dispatch) => {
    dispatch(startRequestComp());
    try {
      await axios.post(url, form, auth).then(resp => {

        dispatch(stopRequestComp("component"))
        dispatch(setSnackbar(resp.data.message, 'success'))
      })
    } catch (error) {
      dispatch(stopRequestComp("component"))
      dispatch(setSnackbar('Error al cargar el archivo:'))
    }
  };
};